import { useStaticQuery, graphql } from "gatsby"
import { mockData } from "./mockData"
export const useMockableImageQuery = () => {
  const mockMetaImages = mockData.metaImages
  try {
    const data = useStaticQuery(graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            xxl: node {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 1920)
              }
              base
            }
            xl: node {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 1440)
              }
              base
            }
            lg: node {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 1280)
              }
              base
            }
            md: node {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 768)
              }
              base
            }
            sm: node {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, width: 480)
              }
              base
            }
          }
        }
      }
    `)

    if (typeof window !== "undefined" && window.__STORYBOOK_CLIENT_API__) {
      return mockMetaImages
    }
    return data
  } catch (Any) {
    return mockMetaImages
  }
}
